import { render, staticRenderFns } from "./CoppieAsseRegione.vue?vue&type=template&id=32857190&scoped=true"
import script from "./CoppieAsseRegione.vue?vue&type=script&lang=js"
export * from "./CoppieAsseRegione.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32857190",
  null
  
)

export default component.exports